import React from 'react'
import illustration from '../../../../../static/images/illustrations/server-down.svg'
import styles from '../../Error.module.scss'

const Maintenance = () => (
  <div className={styles['container']}>
    <img src={illustration} />
    <h1>Site is temporarily unavailable.</h1>
    <p>
      Scheduled maintenance is currently in progress. Please check back soon. <br/>
      We apologize for any inconvenience.
    </p>
    <p id="signature">&mdash; <a href="mailto:support@hipherd.com">Your hipherd team</a></p>
  </div>
)

export default Maintenance
